export const getTotal = (quantity, rangePay, tasa) => {
  const percent = tasa / 100;
  const interes = (quantity * percent) / rangePay;
  return (quantity + interes);
}
